import React from "react";
import { useAppContext } from "../helpers/account-context";

import TagDropdown from "./Search/TagDropdown";
import TypeDropdown from "./Search/TypeDropdown";
import RadiusDropdown from "./Search/RadiusDropdown";

import SearchForm from "./SearchForm";
import RegionsDropdown from "./Search/RegionsDropdown";

// https://stackoverflow.com/questions/49671434/is-there-any-way-to-customize-googles-auto-complete-address-result
// https://developers.google.com/maps/documentation/javascript/examples/geocoding-place-id

// https://developers.google.com/maps/documentation/places/web-service/autocomplete#maps_http_places_autocomplete_fr-rb

const SearchOuter = (props) => {
  const {  getLocale, initedData } = useAppContext()
  const { filters, onChangeFilters, onApplyFilters } = props;

  const handleApplyFilter = (e) => {
    e.preventDefault();
    onApplyFilters();
  }
  
  const handleClear = (e) => {
    e.preventDefault();
    onApplyFilters({
      tags: [],
      search: '',
      lat: '',
      lng: '',
      country: '',
      province: '',
      city: '',
      geo: {}
    });
  }
  
  // https://codepen.io/smithsuth/pen/VvYzZP
  return (
      <div className={`cbmap-search-outer`}>
        <div className="cbmap-search-wrapper">
          <SearchForm 
            {...props} 
            enabledFilterAll={false}
            initedData={initedData}
          />
          <RadiusDropdown filters={filters} onChangeFilters={onChangeFilters} />
        </div>
        {
          (initedData.enabledRegions && initedData.enabledRegions.length > 0) &&  <RegionsDropdown
          {...props}
        />
        }
       
        <div className="cbmap-search-filters">
        <TagDropdown filters={filters} onChangeFilters={onChangeFilters} />
        <TypeDropdown filters={filters} onChangeFilters={onChangeFilters} />
        <RadiusDropdown filters={filters} onChangeFilters={onChangeFilters} />
        <div className="cbmap-search-actions">
          <button 
            className="cbmap-btn cbmap-btn-primary cbmap-btn-apply" 
            type="button" 
            onClick={handleApplyFilter}
          >{getLocale('apply')}</button>
          <button 
            className="cbmap-btn cbmap-btn-outline cbmap-btn-clear" 
            type="button" 
            onClick={handleClear}
          >{getLocale('clear')}</button>
        </div>
        </div>
      </div>

  );
};

export default SearchOuter;
